'use strict';

/**
 * Created by skoda02 on 10/11/16.
 */
var browserHistory = require('react-router').browserHistory;

module.exports = {
    transitionTo: function transitionTo(path, state) {
        var obj = {
            pathname: path
        };
        if (state) {
            obj.state = state;
        }
        browserHistory.push(obj);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/mixins/TransitionMixin.js
// module id = 275
// module chunks = 0